import { Component, OnInit } from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ngx-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.scss'],
  providers: [UtilidadesService,PeticionesHttpBackEndService]
})

export class RegistroComponent implements OnInit {

  DatosBasicosForm: FormGroup;
  DomicilioForm: FormGroup;
  AccesoPlataforma: FormGroup;
  ObjetoRegistro: any;
  RegistroExito : Boolean = false;
  TipoEntidad:any;
  thirdForm:any;
  /* Variables de construcción del objeto */
  Nombre: String = "";
  Apellidos: String = "";
  Telefono: String = "";
  DNICIF: String = "";
  DNICIF2:String ="";
  Email: String = "";
  captchaModel:any;
  mostrarCaptcha: boolean = false;
  /* Selector de empresa/institucion o persona física */
  EsEmpresaInstitucion: number = 0;

  Direccion: String = "";
  Localidad: String = "";
  CodigoPostal: String = "";
  Provincia: String = "";
  Pais: String = "";
  EsParticular: number = 0;
  EsProfesional: number = 0;
  EsAlternativa: number = 0;
  /* Selector de tipo de dirección */
  TipoDireccion: any = false;
  token: any; 
  muestraContenido : Boolean = false;
  emailExiste:Boolean = false;
  OpenModal: any;
  Password: String = "";
  Password2: String = "";
  consentimiento:boolean = false;
  fechaNacimiento:any = undefined;

  DisableNextButtonBasicos: Boolean = true;

  constructor(private fb: FormBuilder, private utilidades: UtilidadesService, private router:Router,public _http: PeticionesHttpBackEndService,private modalService: NgbModal) {

  }

  options = [
    { value: '0', label: 'Soy una persona física', checked: true},
    { value: '1', label: 'Soy una empresa o una institución' },
  ];

  TiposDirecciones = [
    { value: '1', label: 'Es particular', checked: true},
    { value: '2', label: 'Es profesional' },
    { value: '3', label: 'Es alternativa' },
  ];

  ListTipoDocumentos:any;
  ngOnInit() {
    this.DatosBasicosForm = this.fb.group({
      Nombre: ['', Validators.required],
      Apellidos: [''],
      DNICIF: [''],
      dniNo: [''],
      Email: ['',[Validators.required,Validators.email]],
      Telefono: ['', [Validators.required,Validators.pattern]],     
    });
    this.DomicilioForm = this.fb.group({
      Direccion: ['', Validators.required],
      Localidad: ['', Validators.required],
      Provincia: ['', Validators.required],
      CodigoPostal: ['', [Validators.required,Validators.pattern]],
      Pais: ['', Validators.required],
    });

    this.AccesoPlataforma = this.fb.group({
      Password: ['', Validators.required],
      Password2: ['', Validators.required],
    });

    this._http.getAllPublic("getTipoDocumentos").subscribe(
      result => {
        let resultadoTipoDocumentos: any;
         resultadoTipoDocumentos = result;
        this.ListTipoDocumentos = resultadoTipoDocumentos.TipoDocumentos;
        
      },
      error => {

      }
    );

    

  }
  isDniValid:boolean = true;
  isCifValid:boolean = true;
  isCifVacio:boolean = true;
  isDniVacio:boolean = true;
  dniREG = /^([a-z]|[A-Z]|[0-9])[0-9]{7}([a-z]|[A-Z]|[0-9])$/;
  cifREG = /^([a-z]|[A-Z]|[0-9])[0-9]{7}([a-z]|[A-Z]|[0-9])$/;
  onDatosBasicosSubmit() {

    this.DatosBasicosForm.markAsDirty();
   if (this.DatosBasicosForm.status == "INVALID" || this.DisableNextButtonBasicos || !this.EsEmpresaInstitucion){
      this.utilidades.notificationWarning("Error","Tienes que rellenar todos los campos","top-left");
    }
  }
  cambioCif(){
    if(this.DNICIF2 == ''){
      this.isCifVacio = true;
    }else{
      this.isCifVacio = false;
    }
    this.isDniVacio = false;
    this.isDniValid = true;
    this.isCifValid = !this.DNICIF2.match(this.cifREG) ? false : true;
    
  }
  cambioDNI(){
    this.isDniNoVacio = false;
    if(this.DNICIF == ''){
      this.isDniVacio = true;
    } else{
      this.isDniVacio = false;
    }
    this.isCifVacio = false;
    this.isCifValid = true;
    this.isDniValid = !this.DNICIF.match(this.dniREG) ? false : true;

  }
  dniNo:any;
  isDniNoVacio:boolean = true;
  cambioDNINo(){
    if(this.dniNo == ''){
      this.isDniNoVacio = true;
    } else{
      this.isDniNoVacio = false;
    }


  }

  onAccesoPlataformaSubmit() {
    this.AccesoPlataforma.markAsDirty();
    if (this.AccesoPlataforma.status == "INVALID"){
      this.utilidades.notificationWarning("Error","Tienes que rellenar todos los campos","top-left");
    }
  }

  onDomicilioSubmit() {
    this.DomicilioForm.markAsDirty();
    if (this.DomicilioForm.status == "INVALID" || this.TipoDireccion == false){
      this.utilidades.notificationWarning("Error","Tienes que rellenar todos los campos","top-left");
    }else{

        if (this.TipoDireccion == 1){
          this.EsParticular = 1;
          this.EsProfesional = 0;
          this.EsAlternativa = 0;
        }else if(this.TipoDireccion == 2){
          this.EsParticular = 0;
          this.EsProfesional = 1;
          this.EsAlternativa = 0;
        }else {
          this.EsParticular = 0;
          this.EsProfesional = 0;
          this.EsAlternativa = 1;
        }
      
    }

  }

  CompruebaPassword(){
    if (this.Password.length < 8 || this.Password2.length < 8){
      this.utilidades.notificationWarning("Error","La contraseña tiene que tener al menos de 8 caracteres","top-left");
      return false;
    }else{
      if (this.Password != this.Password2){
        this.utilidades.notificationWarning("Error","Las contraseñas tienen que ser identicas","top-left");
        return false;
      }
    } 
    return true; 
  }
  dniGo:any;
  captchaActivo:boolean = false;
  resolved(event: string){
    this.captchaActivo = true;
  }
  FinalizarRegistro(){
    if(this.consentimiento == false){
      this.utilidades.notificationWarning("Error","Debe marcar la opción de consentimiento.","top-left");
    }else{
      if(this.captchaActivo){
          if(this.EsEmpresaInstitucion == 1){
            this.dniGo = this.DNICIF2
          }else{
            this.dniGo = this.tipoDocumentoId == 1 ? (this.EsEmpresaInstitucion == 1 ? this.DNICIF2 : this.DNICIF) : this.dniNo;
          }

          this.ObjetoRegistro = {Nombre:this.Nombre, Apellidos:this.Apellidos, DNICIF: this.dniGo, Email: this.Email, Telefono: this.Telefono, EsEmpresaInstitucion: this.EsEmpresaInstitucion, Direccion: this.Direccion, Localidad: this.Localidad, CodigoPostal: this.CodigoPostal, Provincia: this.Provincia, Pais: this.Pais, EsParticular:this.EsParticular, EsProfesional:this.EsProfesional, EsAlternativa: this.EsAlternativa, Password: this.Password,Consentimiento: this.consentimiento,FechaNacimiento:this.fechaNacimiento != null ? this.fechaNacimiento : new Date(),TipoDocumentoId:this.tipoDocumentoId == 0 ? null : this.tipoDocumentoId}
          let Resultado: any; 
          let Return: Boolean;
          this._http.postRequestPublic('registroPublicoEntidad', {Data:this.ObjetoRegistro}).subscribe(
            result => {
              Resultado = result;
              if (Resultado.Code == 200){
                this.muestraContenido = true;
                this.RegistroExito = true;
              }
            },
            error => {
              this.muestraContenido = true;
              this.RegistroExito = false;
            }
          );
    }else{
      this.utilidades.notificationWarning("Error","Debe completar el tipo de medida de ayuda (CAPTCHA)","top-left");
    }
    }
  }

  VolverInicio(){
    this.router.navigate(['public/inicio']);

  }

  verActividades(){
    this.router.navigate(['public/inicio']);
  }

  masInformacion(informacion){

      this.OpenModal = this.modalService.open(informacion);

  }
  cerrarModal(){
    this.OpenModal.close();
  }

  CheckEmail(event){
    let ResultadoRequest;
    let elemento = event.target.tagName;
    let tipo = event.target.type;
    if ((elemento == "INPUT" && tipo == "text") || (elemento == "INPUT" && tipo == "number")){
      switch(event.target.name){
        case "_email": 
        this._http.postRequestPublic('CheckEmailExist',{Data:{Email:event.target.value}}).subscribe(
          result => {
            ResultadoRequest = result;
            if (ResultadoRequest.Code == 200 && ResultadoRequest.Exist == false){
              this.emailExiste = false;
              this.DisableNextButtonBasicos = false;
            }else{
              this.emailExiste = true;
              this.DisableNextButtonBasicos = true;
              this.utilidades.notificationWarning("Aviso","Este email ya está registrado","top-left");
            }
          },
          error => {

          }
        );
        break;
      }
    }

  }

  aceptarTerminos(event){
    this.mostrarCaptcha = true;
    this.consentimiento = event.target.checked;
  }

  fechaChange(event){
    this.fechaNacimiento = new Date(event);
  }
  tipoDocumentoId = 0;
  cambioTipo(event){
    this.tipoDocumentoId = event;
    this.dniNo = "XXXXX"
  }


}
